import type { TypeCmsUser } from '@/schema'

type TypeUserCookie = {
  token: string,
  exp: string,
  user: TypeCmsUser
}

export const navLinksByRole = {
  'admin': ['invoices'],
}

export const getUserDataFromCookie = (userCookieValue:string):TypeUserCookie => JSON.parse(userCookieValue)
